import { PaintedScene } from '../PaintedScene';

export const SAPLING_FIELDS_PHASER_KEY = 'SaplingFieldsScene' as const;
export const SAPLING_FIELDS_MANIFEST_KEY = 's-103-sapling-fields' as const;

export class SaplingFieldsScene extends PaintedScene {
  constructor() {
    super(SAPLING_FIELDS_PHASER_KEY, SAPLING_FIELDS_MANIFEST_KEY);
  }
}
